// extracted by mini-css-extract-plugin
module.exports = {"header":"App_header_3qzuo","withBreadcrumbs":"App_withBreadcrumbs_3VtPf"};